import API from "@/api/lib/api";

export const getAllSundayRosts = async (restaurant_id) => {
  try {
    const response = await API.get(
      `restaurant/${restaurant_id}/sunday-roast`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleSundayRoast = async (id) => {
  try {
    const response = await API.get(`restaurant/sunday-roast/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createSundayRoast = async (data) => {
  try {
    const response = await API.post(`restaurant/sunday-roast`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateSundayRoast = async (id, data) => {
  try {
    const response = await API.put(`restaurant/sunday-roast/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteSundayRoast = async (id) => {
  try {
    const response = await API.delete(`restaurant/sunday-roast/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
